import React from 'react';
import PropTypes from 'prop-types';
import { Table, Badge, Button, Panel, Row, Col } from 'react-bootstrap';
import { flatMap, forEach, orderBy, groupBy } from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import TableUtils from '../../../../utils/TableUtils';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import './TableBCRA.css';
import lstrings from '../../../../utils/LStrings';

class TableBCRA extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: this.processData(props.data.datos),
			verReferencias: false,
			referencias: [
				{ ref: '0', desc: 'Sin información en BCRA.' },
				{ ref: '1', desc: 'Situación normal (pago puntual o atrasos menores a 31 días).' },
				{ ref: '2', desc: 'Con riesgo potencial (con atrasos entre 31 y 90 días).' },
				{ ref: '3', desc: 'Cumplimiento deficiente (con atrasos entre 90 y 180 días).' },
				{ ref: '4', desc: 'Con alto riesgo de insolvencia (con atrasos entre 180 días y 1 año).' },
				{ ref: '5', desc: 'Irrecuperable (con atrasos mayores a 1 año).' },
				{ ref: '6', desc: 'Irrecuperable por disposición técnica (entidades liquidadas, en proceso de disolución o en quiebra, en gestión judicial).' },
			],
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data: this.processData(nextProps.data.datos)
		});
	}

	lastPeriod = () => {
		return moment();
	}

	processData = (data) => {
		if (data == null)
			return null;

		const monthsKey = [
			"ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"
		];
		
		let info = {};

		forEach(data, (bcraItem) => {
			let periodo = moment(bcraItem.periodo);
			let agno = periodo.year();
			let mes = periodo.month();

			// Inicialización de objetos para el año correspondiente al ítem actual
			if (!info[agno]) {
				// Creo la entrada del año correspondiente
				info[agno] = {
					// Creo un objeto vacío de entidades
					entidades: {},
					anio: agno
				};

				// Configuro el valor por defecto para la entrada [año][mes]
				forEach(monthsKey, (month) => {
					info[agno][month] = {
						valor: 0,
						bcra: false,
						noInfo: false
					};
				});
			}

			// Objeto correspondiente al año
			let infoAgno = info[agno];
			// Sumo el monto al total del mes
			infoAgno[monthsKey[mes]].valor += bcraItem.prestamo;

			// Procesamiento de la entidad
			if (bcraItem.entidad != null) {
				// Compruebo si la entidad está cargada
				if (!infoAgno.entidades[bcraItem.entidad.codigoEnt]) {
					// Agrego la entidad
					infoAgno.entidades[bcraItem.entidad.codigoEnt] = {
						entidad: bcraItem.entidad.entidad,
						id: bcraItem.entidad.codigoEnt,
						tipo: bcraItem.entidad.tipo,
						meses: []
					}

					// Inicializo los valores para la entidad
					for (let x = 0; x < 12; x++) {
						infoAgno.entidades[bcraItem.entidad.codigoEnt].meses.push({
							valor: 0,
							bcra: false,
							noInfo: true,
							situacion: '00'
						})
					}
				}

				// Completo los datos del ítem actual
				infoAgno.entidades[bcraItem.entidad.codigoEnt].meses[mes].valor = bcraItem.prestamo;
				infoAgno.entidades[bcraItem.entidad.codigoEnt].meses[mes].situacion = bcraItem.situacion;
				infoAgno.entidades[bcraItem.entidad.codigoEnt].meses[mes].noInfo = false;
			}
		});

		let result = flatMap(info, (item) => item);
		
		forEach(result, (itemsAgno) => {
			let ultimoPeriodo = 0;
			
            forEach(itemsAgno.entidades, e => {
                let mes = 0;
                forEach(e.meses, m => {
                    mes++;
                    if(ultimoPeriodo <= mes && m.valor > 0){
                        ultimoPeriodo = mes;
                    }
                });
			});
			
			// Ordeno las entidades 
			itemsAgno.entidades = orderBy(
				flatMap(itemsAgno.entidades, (x) => x),
				[`meses[${ultimoPeriodo - 1}].valor`],
				['desc']
			);

			itemsAgno.entidades = groupBy(
				itemsAgno.entidades,
				'tipo'
			);
		});

		return orderBy(result, ['anio'], ['desc']);
	}

	gridOptions = () => {
		return TableUtils.defaultConfig();
	}

	monthCellFormat = (cell) => {
		if (cell.noInfo)
			return '';
		return <span>{TableUtils.ARSFormat(cell.valor, true)}</span>;
	}
	monthColumnFormat = (cell) => {
		if (cell.noInfo)
			return 'noInfo';
		if (cell.bcra)
			return 'bcra';
		return '';
	}

	expandedRow = (row) => {
		let tablasTipoEntidad = [];

		forEach(row.entidades, (entidades, tipoEntidad) => {
			tablasTipoEntidad.push(
				<Table striped bordered condensed fill responsive className="bcraExpandedTipoEntidad">
					<thead>
						<tr>
							<td width={350}><b>{tipoEntidad}</b></td>
							<td>Ene</td>
							<td>Feb</td>
							<td>Mar</td>
							<td>Abr</td>
							<td>May</td>
							<td>Jun</td>
							<td>Jul</td>
							<td>Ago</td>
							<td>Sep</td>
							<td>Oct</td>
							<td>Nov</td>
							<td>Dic</td>
						</tr>
					</thead>
					<tbody>
						{entidades.map((item, ix) => {
							if (item === null)
								return <tr key={ix}></tr>;
							return (<tr key={ix}>
								<td className="bcraEntidadTitle" title={item.entidad}>{item.entidad}</td>
								{item.meses.map((cell, ix2) => {
									if (cell.noInfo)
										return <td
											key={ix2} className={'noInfo'}
											title={this.state.referencias[0].desc}
										></td>;
									let valor = '';
									if (cell.valor >= 0)
										valor = TableUtils.ARSFormat(cell.valor, true);
									
									return <td
										key={ix2}
										style={{ textAlign: 'center' }}>
										{valor}<br/>
										<Badge
											className={`situacion-${cell.situacion}`}
											title={this.state.referencias[parseInt(cell.situacion, 10)].desc}
										>
											{numeral(cell.situacion).format()}
										</Badge>
									</td>;
								})}
							</tr>);
						})}
					</tbody>
				</Table >
			)
		});

		return tablasTipoEntidad;
	}

	verReferencias = () => {
		this.setState({
			verReferencias: !this.state.verReferencias
		});
	}

	render() {
		return (
			<div>
				<p>
					{lstrings.infobcra_subtitle}
				</p>
				<BootstrapTable data={this.state.data}
					expandableRow={() => true}
					expandComponent={this.expandedRow}
					options={this.gridOptions()}>
					<TableHeaderColumn
						dataField="anio"
						width='30'
						dataFormat={TableUtils.plusButtonFormat}
					></TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="anio"
						isKey
					>Período</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="ene"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Ene</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="feb"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Feb</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="mar"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Mar</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="abr"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Abr</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="may"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>May</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="jun"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Jun</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="jul"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Jul</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="ago"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Ago</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="sep"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Sep</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="oct"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Oct</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="nov"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Nov</TableHeaderColumn>
					
					<TableHeaderColumn
						dataField="dic"
						dataFormat={this.monthCellFormat}
						columnClassName={this.monthColumnFormat}
					>Dic</TableHeaderColumn>
				</BootstrapTable>

				<p><strong>Último período informado en CD del BCRA: </strong>{this.lastPeriod() !== null ? this.lastPeriod().subtract(3, 'months').format('MMMM YYYY') : ''}</p>
				{/* 
                    TODO
                    indica que el período fue enriquecido a través de BCRA Online.
                    */}
				<Row>
					<Col sm={4} smOffset={1}>
						<Button bsStyle="primary" className="btn-block" onClick={this.verReferencias} >Ver referencias</Button>
					</Col>
					<Col sm={4} smOffset={2}>
						<Button bsStyle="primary" target="_blank" className="btn-block" href="http://www.bcra.gob.ar/BCRAyVos/Situacion_Crediticia.asp">Ver Banco Central - Online</Button>
					</Col>
				</Row>

				<Panel collapsible expanded={this.state.verReferencias} >
					<Table striped bordered condensed fill responsive>
						<thead>
							<tr>
								<td width={300}>Situación</td>
								<td>Descripción</td>
							</tr>
						</thead>
						<tbody>
							{this.state.referencias.map((item, ix) => <tr key={ix}>
								<td style={{ textAlign: 'center' }}>
									<Badge
										className={`situacion-${numeral(ix).format('00')}`}>{item.ref}
									</Badge>
								</td>
								<td>{item.desc}</td>
							</tr>)}
						</tbody>
					</Table>
				</Panel>
				<Row>

				</Row>
			</div>
		);
	}

}

TableBCRA.propTypes = {
	data: PropTypes.array,
	onRequestInfo: PropTypes.func,
	hidePanels: PropTypes.any
}

export default TableBCRA;



// WEBPACK FOOTER //
// ./src/components/panel-situacion-financiera/components/table-bcra/TableBCRA.js